import React, {useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"

import "./Test.css"

import Nav from "../../component/Nav/Nav"
import Footer from "../../component/Footer/Footer"
import SubBanner from "../../component/SubBanner/SubBanner"
import {retrieveData} from "../../common";

function Examination() {

	const navigate = useNavigate()

	const [user, setUser] = useState()

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
		})
	}, [])

	return (
		<>
			<Nav user={user} />
			<SubBanner title={"온라인 검사"} firstText={"인컬리지의 공인된"} lastText={"심리검사를 실시해보세요."} />
			<div className="container">
				<div className="cardContent examination">
					<section>
						<h4>온라인 검사</h4>
						<p>온라인 검사실시를 위한 검사진행 방식을 선택해주세요.</p>
						<div className="examWrap">
							<div className="examCard">
								<h5>인증코드 검사 실시</h5>
								<div>
									<p>인증코드 방식의 검사 실시</p>
									<span>수검자에게 인증코드를 발송하고,
									수검자는 링크를 통해 진행하는 방식입니다.</span>
									<button
										type="button"
										onClick={() => {
											if (!user || !user?.isExpert) {
												alert('전문가 회원만 볼 수 있습니다.')
												return
											}
											navigate("/personal-code")
										}}>인증코드 관리</button>
								</div>
							</div>
							<div className="examCard">
								<h5>웹 검사 실시</h5>
								<div>
									<p>웹(모바일/PC)에서의 검사실시</p>
									<span>모바일 혹은 PC 웹으로 접속하여
										검사를 진행하는 방식입니다.</span>
									<button
										type="button"
										onClick={() => {
											navigate("/start-test")
										}}>검사실시</button>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>

			<Footer />
		</>
	)
}

export default Examination
